import { useState } from 'react'
import { CalendarIcon } from './Icons'

function friendlyAuthError(error) {
  const message = String(error?.message || '').toLowerCase()

  if (message.includes('invalid login credentials')) {
    return 'Email or password is incorrect.'
  }

  if (message.includes('email not confirmed')) {
    return 'This account is not active yet. Ask the administrator to confirm it.'
  }

  if (error?.status === 429 || message.includes('too many') || message.includes('rate limit')) {
    return 'Too many login attempts. Wait a few minutes and try again.'
  }

  return error?.message || 'Sign-in failed.'
}

export default function Login({ onSignIn }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(event) {
    event.preventDefault()
    if (busy) return

    setBusy(true)
    setError('')

    try {
      await onSignIn(email.trim(), password)
    } catch (signInError) {
      setError(friendlyAuthError(signInError))
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="login-page">
      <section className="login-panel">
        <div className="login-card">
          <div className="login-logo">
            <span className="brand-mark"><CalendarIcon size={22} /></span>
            <strong>TimeGrid</strong>
          </div>

          <h1>Sign in</h1>

          <form className="login-form" onSubmit={handleSubmit}>
            <label className="field-label" htmlFor="login-email">
              Email
              <input
                autoComplete="username"
                autoFocus
                id="login-email"
                onChange={(event) => setEmail(event.target.value)}
                placeholder="you@company.com"
                required
                type="email"
                value={email}
              />
            </label>

            <label className="field-label" htmlFor="login-password">
              Password
              <input
                autoComplete="current-password"
                id="login-password"
                minLength="8"
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Enter your password"
                required
                type="password"
                value={password}
              />
            </label>

            <button
              className="button button--primary button--full button--large"
              disabled={busy}
              type="submit"
            >
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <div aria-live="polite">
            {error ? <p className="auth-message auth-message--error">{error}</p> : null}
          </div>
        </div>
      </section>
    </main>
  )
}
